export default __webpack_public_path__ + "static/media/ziplining4.9dfbab53.webp";